<template>
    <div>
        <header>
            <div class="container-fluid">
                <div id="top" class="row">
                    <div class="col text-center">
                        <router-link to='/' class="logo">
                            <img src="/images/logo.png" alt="De Duursportcoach">
                        </router-link>
                        <a class="navigation-toggle d-inline d-lg-none" @click="toggleNavigation">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars" role="img"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path fill="currentColor"
                                      d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
                            </svg>
                        </a>
                        <nav class="navbar navbar-expand-lg navbar-dark" v-if="showNavigation">
                            <div class="collapse navbar-collapse" id="navigation">
                                <ul class="navbar-nav ml-auto">
                                    <li class="nav-item active">
                                        <a href="#wie-ben-ik" class="nav-link" v-smooth-scroll>Wie ben ik</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#voor-wie" class="nav-link" v-smooth-scroll>Voor wie</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#inhoud" class="nav-link" v-smooth-scroll>Inhoud
                                            trainingsbegeleiding</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#diensten" class="nav-link" v-smooth-scroll>Overige diensten</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#contact" class="nav-link" v-smooth-scroll>Contact</a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </header>

        <main role="main" class="pt-lg-5">
            <section id="home">

                <div class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5">
                                <h1 class="text-blue">Het gaat er niet om de beste te zijn,<br>
                                    maar om elke dag beter worden.
                                </h1>
                                <small class="text-blue">(Esther Vergeer)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="wie-ben-ik" class="container-wrapper-red">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-md-6 col-image order-2 order-md-1">
                                <img src="/images/wie-ben-ik.png" alt="Hans Romers">
                            </div>
                            <div class="col-12 col-md-6 pt-5 pb-4 text-white order-1 order-md-2">
                                <h2>Wie ben ik?</h2>
                                <p>
                                    Ik ben Hans Romers geboren 6 juli 1974, afgestudeerd
                                    aan de Haagse Academie voor Lichamelijke Opvoeding
                                    in 1996. Tijdens de academie gespecialiseerd in
                                    inspanningsfysiologie onder leiding van Jos Geijsel en
                                    Adrie van Diemen.
                                </p>
                                <p>
                                    Vanaf mijn 16<sup>de</sup> t/m 22<sup>ste</sup> actief geweest in de triatlonsport.
                                    Door een blessure noodgedwongen gestopt en in het
                                    wielrennen terecht gekomen. Naast zelf actief wielrennen
                                    startte ik met het begeleiden van triatleten en wielrenners.
                                    Dit deed ik naast mijn baan als docent aan de opleiding
                                    ROC Mondriaan Lifestyle Sport en Bewegen. Hier ben ik docent
                                    trainingsleer en Gezonde Leefstijl. Sinds 2019 ben ik begonnen
                                    met mijn bedrijf De Duursportcoach en begeleid ik met
                                    veel passie mijn sporters.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5 text-right">
                                <h1 class="text-blue">Het wordt nooit makkelijker,<br>
                                    je gaat gewoon sneller!</h1>
                                <small class="text-blue">(Greg Lemond)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="voor-wie" class="container-wrapper-yellow">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-md-6 pt-5 pb-5 text-blue">
                                <h2>Voor wie is de trainingsbegeleiding?</h2>
                                <p>
                                    Voor wielrenners, triatleten en hardlopers.
                                    Van recreant tot topsporter die professioneel
                                    begeleid willen worden waarbij balans centraal staat.
                                    Balans tussen belasting die je jezelf oplegt en de
                                    belastbaarheid die je lichaam aankan. Door goed
                                    evenwicht tussen inspanning en herstel zal je
                                    vorderingen maken en je doelen bereiken.
                                </p>
                            </div>
                            <div class="col-12 col-md-6 col-image">
                                <img src="/images/voor-wie.png" alt="Voor wie is de trainingsbegeleiding?">
                            </div>
                        </div>
                    </div>
                </div>


                <div class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5">
                                <h1 class="text-blue">Ik begeleid wielrenners,<br>
                                    triatleten en hardlopers.
                                </h1>
                                <small class="text-blue">(Hans Romers)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="inhoud" class="container-wrapper-green">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-md-6 col-image order-2 order-md-1">
                                <img src="/images/inhoud.png" alt="Inhoud trainingsbegeleiding">
                            </div>
                            <div class="col-12 col-md-6 pt-5 pb-5 text-white order-1 order-md-2">
                                <h2>Inhoud trainingsbegeleiding</h2>
                                <p>
                                    Begeleiding op maat staat centraal. Voorafgaand aan de
                                    begeleiding houden we een intakegesprek om beginsituatie
                                    en doelen vast te stellen. Wekelijks of tweewekelijks of
                                    maandelijks contact om trainingsschema’s te evalueren en
                                    vooruit te kijken naar de toekomstige trainingsperiode.
                                    Daarnaast zullen we periodiek testen om vooruitgang te meten.
                                    De trainingsschema’s worden gemaakt met behulp van
                                    Trainingpeaks, via dit programma analyseer ik de trainingen
                                    en breng jouw ontwikkelingen in kaart. Zo kan ik jou
                                    goed volgen en trainingen bijstellen waar nodig.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5 text-right">
                                <h1 class="text-blue">Het lijkt altijd onmogelijk<br>
                                    totdat het is gedaan.
                                </h1>
                                <small class="text-blue">(Nelson Mandela)</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="diensten" class="container-wrapper-blue">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5 text-white">
                                <h2>Overige diensten</h2>
                                <p>
                                    Naast het maken van trainingsschema’s begeleid ik ook mensen die een gezondere
                                    leefstijl
                                    willen bereiken en geef ik
                                    trainingen en workshops op afspraak.
                                    <br>
                                    <br>
                                    <b>Voorbeelden van workshops/trainingen</b>
                                    <br>
                                    <br>
                                    <b>Achtergronden van trainen:</b><br>
                                    Leren toepassen van de verschillende trainingsmethodes, balans tussen
                                    belasting/belastbaarheid, periodisering.<br>
                                    <br>
                                    <b>Duursportvoedingsadvies en voedingsvoorlichtingvoorlichting:</b><br>
                                    Wat moet je eten, hoeveel en wanneer?
                                    <br>
                                    <br>
                                    <b>Coaching on the job:</b><br>
                                    Samen trainen met directe feedback: op juiste manier uitvoeren trainingsmethodes,
                                    testen,
                                    rijvaardigheidstraining en
                                    loopscholing.
                                    <br>
                                    <br>
                                    <b>Begeleiding van een groepsrit met uw bedrijf of vriendengroep:</b><br>
                                    Zin in een leuke tocht met je collega’s of vrienden met voorafgaand/na afloop info
                                    over
                                    trainen/voeding. En tijdens de rit
                                    indien gewenst rijvaardigheidstraining in een groep.
                                    <br>
                                    <br>
                                    <b>Beweegcoach:</b><br>
                                    Wil je fitter worden, verzorg ik ook trainingen op maat, dit doe ik buiten. Samen
                                    aan
                                    de slag om meer kracht te krijgen, een beter uithoudingsvermogen en zo een stuk
                                    gezonder te worden. Hiernaast ook de
                                    mogelijkheid om aan ontspanning te werken. Samen op weg naar een gezondere
                                    leefstijl!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="contact" class="container-wrapper-white">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col pt-5 pb-5 text-blue">
                                <h2>Contact</h2>
                                <p>
                                    Voor meer informatie en kosten kun je contact opnemen met:<br><br>

                                    De Duursportcoach<br>
                                    Hans Romers<br><br>
                                    <a class="text-blue" href="mailto:hansromers@gmail.com">hansromers@gmail.com</a><br>
                                    <a class="text-blue" href="tel:+31611275882">+316 112 758 82</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showNavigation: false
        }
    },
    methods: {
        toggleNavigation() {
            this.showNavigation = !this.showNavigation;
        },
        handleResize() {
            this.showNavigation = window.innerWidth >= 992;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
}
</script>
